import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import CustomBadge from "@/components/desktop/badge/CustomBadge";
import { useQueryClient } from "react-query";

import { key, useOrderPaginate } from "@/hooks/purchases/orders";

import { agricolaName, dateToLocale, formatMiles, formatMilesDecimal, formatMilesDecimalNew, round } from "@/services/Utils";
import CustomTooltip from "@/components/desktop/tooltip/CustomTooltip";
import { ReactComponent as ArrowUpSvg } from "@/assets/images/desktop/Flechaverdehorizontal.svg";
import { ReactComponent as ArrowDownSvg } from "@/assets/images/desktop/flechaverdeabajo.svg";
import { ReactComponent as FolderSvg } from "@/assets/images/desktop/folder-move.svg";

import OrdersActionItem from "./Action/OrdersActionItem";
import OrdersTableBodyDetail from "./OrdersTableBodyDetail";

import classes from "../../purchase.module.scss";

const OrdersTableBody = ({ base }) => {
	const queryClient = useQueryClient();
	const { customer } = useSelector((state) => state.auth.user);

	const { data } = useOrderPaginate(base);

	const handleDocumentClick = (index) => {
		queryClient.setQueryData([key, { ...base }], (oldData) => {
			const newData = { ...oldData };
			newData.list.data[index].show_document = !newData.list.data[index].show_document;
			return newData;
		});
	};

	const handleActionClick = (index) => {
		queryClient.setQueryData([key, { ...base }], (oldData) => {
			const newData = { ...oldData };
			newData.list.data.forEach((element, j) => {
				if (j !== index) {
					newData.list.data[j].active = false;
				}
			});

			newData.list.data[index].active = !newData.list.data[index].active;
			return newData;
		});
	};

	return (
		<tbody>
			{data?.list?.data?.map((item, i) => {
				return [
					<tr key={i} className={`${classes.table_tr}`}>
						<td className={`${classes.table_td} ${classes.first_td}`}>
							<div
								className={`${classes.table_div} ${item.active && classes.active} ${classes.first_div} ${classes.long_text} ${classes.center}`}
							>
								<CustomTooltip text={agricolaName(item.business_name)} description={item.business_name} />
							</div>
						</td>
						<td className={`${classes.table_td}`}>
							<div className={`${classes.table_div} ${item.active && classes.active} ${classes.long_text} ${classes.center}`}>
								{item && item.date_create_order && dateToLocale(item.date_create_order)}
							</div>
						</td>
						<td className={`${classes.table_td}`}>
							<div className={`${classes.table_div} ${item.active && classes.active} ${classes.long_text} ${classes.center}`}>
								<CustomTooltip
									text={item.dealer_name.length < 5 ? item.dealer_name : agricolaName(item.dealer_name)}
									description={item.dealer_name}
								/>
							</div>
						</td>
						<td className={`${classes.table_td} `}>
							<div className={`${classes.table_div} ${item.active && classes.active} ${classes.long_text}`}>{item && item.code_oc}</div>
						</td>
						<td className={`${classes.table_td}`}>
							<div className={`${classes.table_div} ${item.active && classes.active}`}>
								{Number(item.state_id) === 1 && <CustomBadge variant="neutral">{item.state_name}</CustomBadge>}
								{Number(item.state_id) === 2 && <CustomBadge variant="success">{item.state_name}</CustomBadge>}
								{Number(item.state_id) === 3 && <CustomBadge variant="danger">{item.state_name}</CustomBadge>}
							</div>
						</td>
						<td className={`${classes.table_td}`}>
							<div className={`${classes.table_div} ${item.active && classes.active} ${classes.long_text}`}>
								{item && item.date_order && dateToLocale(item.date_order)}
							</div>
						</td>
						<td className={`${classes.table_td}`}>
							<div
								className={`${classes.table_div} ${item.active && classes.active}`}
								style={{
									textAlign: "center",
									backgroundColor:
										Number(item.reception.replace(",", ".")) < 100
											? "#ff030359"
											: Number(item.reception.replace(",", ".")) === 100 && "#7fb02f59",
									color: Number(item.reception.replace(",", ".")) < 100 ? "red" : Number(item.reception.replace(",", ".")) === 100 && "green",
								}}
							>
								{item && item.reception ? formatMilesDecimalNew(item.reception) : 0}%
							</div>
						</td>
						{!!customer.use_estates_parents && (
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${item.active && classes.active} ${classes.long_text}`}>
									<CustomTooltip text={agricolaName(item.estate_parent_name)} description={item.estate_parent_name} />
								</div>
							</td>
						)}
						<td className={`${classes.table_td}`}>
							<div className={`${classes.table_div} ${item.active && classes.active} ${classes.long_text} ${classes.center}`}>
								<CustomTooltip text={agricolaName(item.estate_name)} description={item.estate_name} />
							</div>
						</td>
						<td className={`${classes.table_td}`}>
							<div className={`${classes.table_div} ${item.active && classes.active} ${classes.number}`}>
								{item && formatMiles(item.quantity)}
							</div>
						</td>
						<td className={`${classes.table_td}`}>
							<div className={`${classes.table_div} ${item.active && classes.active} ${classes.number}`}>
								${formatMilesDecimal(round(item.price_total, 3))}
							</div>
						</td>
						<td className={`${classes.table_td}`}>
							<div style={{ position: "relative" }} className={`${classes.table_div} ${item.active && classes.active}`}>
								<OrdersActionItem base={base} item={item} index={i} />
							</div>
						</td>
						<td className={`${classes.table_td}`}>
							<div className={`${classes.table_div} ${item.active && classes.active} ${classes.center} ${classes.document_list}`}>
								<FolderSvg className={classes.document_button} onClick={() => handleDocumentClick(i)} />

								<Modal show={Boolean(item.show_document)} onHide={() => handleDocumentClick(i)} backdrop="static" keyboard={false}>
									<Modal.Header closeButton>
										<Modal.Title style={{ fontSize: "1em" }}>Documentos</Modal.Title>
									</Modal.Header>
									<Modal.Body>
										{item.documents &&
											item.documents.map((file, j) => {
												return (
													<div key={j} className={classes.document_modal}>
														<div className={classes.document_number}>{j + 1}.</div>
														<div
															className={classes.document_name}
															onClick={() => {
																const link = document.createElement("a");
																link.href = file.url;
																link.download = file.name;
																if (["pdf", "png", "jpeg", "jpg"].includes(file.extension)) {
																	link.target = "_blank";
																}
																link.click();
															}}
														>
															{file.name}
														</div>
													</div>
												);
											})}
									</Modal.Body>
								</Modal>
							</div>
						</td>
						<td onClick={() => handleActionClick(i)} className={`${classes.table_td}`}>
							<div style={{ position: "relative" }} className={`${classes.table_div} ${item.active && classes.active} ${classes.last_div}`}>
								{item.active ? <ArrowDownSvg /> : <ArrowUpSvg />}
							</div>
						</td>
					</tr>,
					<OrdersTableBodyDetail item={item} key={`detail_${i}`} />,
				];
			})}
		</tbody>
	);
};

export default OrdersTableBody;
